module.exports = __webpack_public_path__ + "static/img/icon_expand_category_white.c1b7cb5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_expand_category_white.svg
// module id = xSS4
// module chunks = 10